import React, { useState, useEffect } from "react";
import { Col, Row, Form, Badge, Label } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import Buttons from "../buttons/button-primary";
import { InputText } from "../inputs/text-input";
import validate from "./register-business-validation";
import Textarea from "../inputs/textarea";
import InputNumber from "../inputs/number-input";
import Select from "../inputs/select";
import SearchSelect from "../inputs/search-select";
import { getServedCities } from '../../redux/actions/servedCItiesList';


//- Business Form ==> Register Page 
const RegisterBusiness = (props) => {
    // const dispatch = useDispatch();
    // const cities = useSelector(state => state.servedCities.cities);
    // const citiesLoading = useSelector(state => state.servedCities);
    // const citiesError = useSelector(state => state.servedCities);

    const [state, setState] = useState({
        company: "",
        companyType: "",
        businessAddress: "",
        zipCode: "",
        servedCities: "",
        mileRadius: "",
        cityKey: "",
        currentChangingCityId: "",
        selectedCities: [],
        yearsOfBusiness: "",

        companyError: "",
        companyTypeError: "",
        businessAddressError: "",
        zipCodeError: "",
        servedCitiesError: "",
        mileRadiusError: "",
        yearsOfBusinessError: "",
        valid: false,

        // Updated Areas Served structure to match mobile app
        zipcodeList: [{ zipcode: '', radius: '' }],
        radiusError: "",
    });

    // Debug: Monitor state changes
    useEffect(() => {
        console.log('State updated:', {
            company: state.company,
            companyType: state.companyType,
            businessAddress: state.businessAddress,
            zipCode: state.zipCode,
            yearsOfBusiness: state.yearsOfBusiness
        });
    }, [state.company, state.companyType, state.businessAddress, state.zipCode, state.yearsOfBusiness]);

    const handleInputChange = (event) => {
        console.log('Input change:', event.target.name, 'Value:', event.target.value);
        setState((prevProps) => {
            const newState = {
                ...prevProps,
                [event.target.name]: event.target.value || "",
            };
            console.log('New state for', event.target.name, ':', newState[event.target.name]);
            return newState;
        });
    };

    // Handle zipcode input change
    const handleZipcodeChange = (index, value) => {
        // Limit to 5 digits
        const zipcode = value ? value.toString().slice(0, 5) : '';
        
        console.log('Before zipcode change, current state:', {
            company: state.company,
            companyType: state.companyType,
            businessAddress: state.businessAddress,
            zipCode: state.zipCode,
            yearsOfBusiness: state.yearsOfBusiness
        });
        
        setState(prevState => {
            const updated = [...prevState.zipcodeList];
            updated[index].zipcode = zipcode;
            const newState = { ...prevState, zipcodeList: updated };
            
            console.log('After zipcode change, new state:', {
                company: newState.company,
                companyType: newState.companyType,
                businessAddress: newState.businessAddress,
                zipCode: newState.zipCode,
                yearsOfBusiness: newState.yearsOfBusiness
            });
            
            return newState;
        });
    };

    // Handle radius input change
    const handleRadiusChange = (index, value) => {
        console.log('Before radius change, current state:', {
            company: state.company,
            companyType: state.companyType,
            businessAddress: state.businessAddress,
            zipCode: state.zipCode,
            yearsOfBusiness: state.yearsOfBusiness
        });
        
        setState(prevState => {
            const updated = [...prevState.zipcodeList];
            updated[index].radius = value;
            const newState = { ...prevState, zipcodeList: updated };
            
            console.log('After radius change, new state:', {
                company: newState.company,
                companyType: newState.companyType,
                businessAddress: newState.businessAddress,
                zipCode: newState.zipCode,
                yearsOfBusiness: newState.yearsOfBusiness
            });
            
            return newState;
        });
    };

    // Handle input blur - add new entry if current is valid
    const handleInputBlur = (index) => {
        const currentEntry = state.zipcodeList[index];
        const isValid = currentEntry.zipcode && 
                       currentEntry.zipcode.length === 5 && 
                       currentEntry.radius && 
                       !isNaN(currentEntry.radius) && 
                       Number(currentEntry.radius) > 0 && 
                       Number(currentEntry.radius) <= 90;

        // If current entry is valid and it's the last entry, add a new one
        if (isValid && index === state.zipcodeList.length - 1) {
            setState(prevState => ({
                ...prevState,
                zipcodeList: [...prevState.zipcodeList, { zipcode: '', radius: '' }],
                radiusError: ''
            }));
        }
    };

    // Remove zipcode entry
    const removeZipcodeEntry = (index) => {
        if (state.zipcodeList.length > 1) {
            console.log('Before removing zipcode entry, current state:', {
                company: state.company,
                companyType: state.companyType,
                businessAddress: state.businessAddress,
                zipCode: state.zipCode,
                yearsOfBusiness: state.yearsOfBusiness
            });
            
            setState(prevState => {
                const updated = prevState.zipcodeList.filter((_, i) => i !== index);
                const newState = { ...prevState, zipcodeList: updated };
                
                console.log('After removing zipcode entry, new state:', {
                    company: newState.company,
                    companyType: newState.companyType,
                    businessAddress: newState.businessAddress,
                    zipCode: newState.zipCode,
                    yearsOfBusiness: newState.yearsOfBusiness
                });
                
                return newState;
            });
        }
    };

    // Validate zipcode format
    const isValidZipcode = (zipcode) => {
        return zipcode && zipcode.length === 5 && !isNaN(zipcode);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        
        // Debug: Log current state values
        console.log('Current state values:', {
            company: state.company,
            companyType: state.companyType,
            businessAddress: state.businessAddress,
            zipCode: state.zipCode,
            yearsOfBusiness: state.yearsOfBusiness
        });
        
        // Run all validations at once
        const errors = validate(state);
        console.log('Imported validation errors:', errors);
        let hasErrors = false;
        
        // Check Areas Served validation
        const filteredZipcodeList = (state.zipcodeList || []).filter(entry =>
            entry.zipcode &&
            entry.zipcode.length === 5 &&
            !isNaN(entry.zipcode) &&
            entry.radius &&
            !isNaN(entry.radius) &&
            Number(entry.radius) > 0 &&
            Number(entry.radius) <= 90
        );

        if (filteredZipcodeList.length === 0) {
            errors.radiusError = "At least one valid zipcode and miles entry is required";
            errors.valid = false;
            hasErrors = true;
        }

        // Check if company type is selected
        console.log('Checking company type:', state.companyType, 'Result:', !state.companyType || state.companyType === "0");
        if (!state.companyType || state.companyType === "0") {
            errors.companyTypeError = "Please select a Company Type";
            errors.valid = false;
            hasErrors = true;
        }

        // Check if business address is provided
        console.log('Checking business address:', state.businessAddress, 'Result:', !state.businessAddress || state.businessAddress.trim() === "");
        if (!state.businessAddress || state.businessAddress.trim() === "") {
            errors.businessAddressError = "Please enter the address";
            errors.valid = false;
            hasErrors = true;
        }

        // Check if main business zipcode is provided
        if (!state.zipCode || state.zipCode.length !== 5 || isNaN(state.zipCode)) {
            errors.zipCodeError = "Business zipcode should be 5 digits";
            errors.valid = false;
            hasErrors = true;
        }

        // Set all errors at once in a single state update
        setState((prevProps) => ({
            ...prevProps,
            companyError: errors.companyError || "",
            companyTypeError: errors.companyTypeError || "",
            businessAddressError: errors.businessAddressError || "",
            zipCodeError: errors.zipCodeError || "",
            yearsOfBusinessError: errors.yearsOfBusinessError || "",
            radiusError: errors.radiusError || "",
            valid: errors.valid
        }));

        // If there are errors, don't proceed
        if (hasErrors || !errors.valid) {
            return;
        }

        // Create the payload structure matching mobile app
        let selected_cities = filteredZipcodeList.map(entry => ({
            radius: entry.radius,
            zipcode: entry.zipcode
        }));

        const data = {
            street_address: state.businessAddress,
            zipcode: state.zipCode, // This should be the business zipcode
            company_name: state.company,
            company_type: state.companyType,
            provider_locations_attributes: selected_cities,
            years_of_business: state.yearsOfBusiness,
        }
        
        console.log(data,'data');
        props.handleRegisterBusiness(data);
    }

    const companies = [
        { label: "Company Type *", value: "0" },
        { label: "Sole Proprietor", value: "1" },
        { label: "LLC", value: "2" },
        { label: "Corp", value: "3" }
    ]

    return (
        <Form className="ebw-entry__register-form text-center mt-2" onSubmit={handleSubmit}>
            <Row form>
                <Col sm="12">
                    <InputText
                        label="Company Name *"
                        name="company"
                        id="register_company"
                        value={state.company}
                        error={state.companyError}
                        changeEvent={handleInputChange}
                    />
                </Col>

                <Col sm="12">
                    <Select
                        name="companyType"
                        label="Company Type *"
                        id="register_address"
                        value={state.companyType}
                        error={state.companyTypeError}
                        changeEvent={handleInputChange}
                        data={companies}
                        
                    />
                </Col>

                <Col sm="12">
                    <Textarea
                        label="Business Address *"
                        name="businessAddress"
                        id="register_address"
                        value={state.businessAddress}
                        error={state.businessAddressError}
                        changeEvent={handleInputChange}
                    />
                </Col>

                <Col sm="12">
                    <InputNumber
                        label="Zip Code *"
                        name="zipCode"
                        type="number"
                        maxLength="5"
                        id="register_zipcode"
                        value={state.zipCode}
                        error={state.zipCodeError}
                        changeEvent={(e) => {
                            // Limit to 5 digits like the Areas Served fields
                            const value = e.target.value;
                            const zipcode = value ? value.toString().slice(0, 5) : '';
                            setState(prevState => ({
                                ...prevState,
                                zipCode: zipcode
                            }));
                        }}
                    />
                </Col>
            </Row>

            <Row form>
                <Col xs="12" className="mb-2 mt-2">
                    <Label className="ebw-profile__type-text ebw-profile__name-gray text-left w-100">Areas Served *</Label>
                </Col>
                
                {/* Areas Served Input Fields - Repeated structure like mobile app */}
                <Col xs="12">
                    <div className="d-flex flex-column" style={{ gap: '0.25em' }}>
                        {state.zipcodeList.map((entry, idx) => {
                            const isLast = idx === state.zipcodeList.length - 1;
                            const isValid = entry.zipcode && 
                                           entry.zipcode.length === 5 && 
                                           entry.radius && 
                                           !isNaN(entry.radius) && 
                                           Number(entry.radius) <= 90;
                            
                            return (
                                <div className="d-flex flex-column mb-1" key={idx}>
                                    <div className="d-flex align-items-center" style={{ gap: '0.5em' }}>
                                        <div style={{ width: '50%' }}>
                                            <InputNumber
                                                label={idx === 0 ? "Zip Code Served *" : "Zip Code Served *"}
                                                name={`zipcode-${idx}`}
                                                id={`register_zipcode_${idx}`}
                                                type="number"
                                                maxLength="5"
                                                value={entry.zipcode}
                                                changeEvent={(e) => handleZipcodeChange(idx, e.target.value)}
                                                onBlur={() => handleInputBlur(idx)}
                                            />
                                            {/* Zipcode validation error */}
                                            {((!entry.zipcode && entry.radius) || (!isValidZipcode(entry.zipcode) && entry.zipcode)) && (
                                                <p className="es-entry-error mt-1" style={{ color: 'red', fontSize: '0.875em', textAlign: 'left' }}>
                                                    {!entry.zipcode ? 'Zipcode is required' : 'Zipcode should be 5 digits'}
                                                </p>
                                            )}
                                        </div>
                                        
                                        <div style={{ width: '50%' }}>
                                            <InputNumber
                                                label={idx === 0 ? "Miles Radius *" : "Miles Radius *"}
                                                name={`radius-${idx}`}
                                                id={`register_radius_${idx}`}
                                                type="number"
                                                maxLength="2"
                                                value={entry.radius}
                                                changeEvent={(e) => handleRadiusChange(idx, e.target.value)}
                                                onBlur={() => handleInputBlur(idx)}
                                            />
                                            {/* Radius validation error */}
                                            {entry.radius && Number(entry.radius) > 90 && (
                                                <p className="es-entry-error mt-1" style={{ color: 'red', fontSize: '0.875em', textAlign: 'left' }}>
                                                    Service area should be within 90 miles
                                                </p>
                                            )}
                                        </div>
                                        
                                        {/* Cross button - inline with fields */}
                                        {!isLast && state.zipcodeList.length > 1 && (
                                            <div className="d-flex align-items-center" style={{  }}>
                                                <button
                                                    type="button"
                                                    style={{
                                                        fontSize: '1.2em',
                                                        background: 'none',
                                                        color: '#111',
                                                        border: 'none',
                                                        fontWeight: 'bold',
                                                        width: '1.5em',
                                                        height: '1.5em',
                                                        borderRadius: '50%',
                                                        background: '#e5e7eb',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        lineHeight: 1,
                                                        padding: 0,
                                                        // marginBottom: '1.5em'
                                                    }}
                                                    onClick={() => {
                                                        if (state.zipcodeList.length > 1) {
                                                            setState(prevState => {
                                                                const updated = prevState.zipcodeList.filter((_, i) => i !== idx);
                                                                return { ...prevState, zipcodeList: updated };
                                                            });
                                                        }
                                                    }}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Plus button for last entry */}
                                    {isLast && (
                                        <div className="d-flex justify-content-end mt-1">
                                            <span
                                                style={{
                                                    color: '#2563eb',
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    fontSize: '1em',
                                                    marginTop: '0em',
                                                    userSelect: 'none'
                                                }}
                                                onClick={() => {
                                                    // Validate last entry before adding
                                                    const last = state.zipcodeList[state.zipcodeList.length - 1];
                                                    const valid = last && 
                                                                 last.zipcode && 
                                                                 last.zipcode.length === 5 && 
                                                                 last.radius && 
                                                                 !isNaN(last.radius) && 
                                                                 Number(last.radius) > 0 && 
                                                                 Number(last.radius) <= 90;
                                                    if (!valid) {
                                                        setState(prevState => ({ 
                                                            ...prevState, 
                                                            radiusError: 'Please enter a valid zipcode (5 digits) and miles (1-90) before adding another.' 
                                                        }));
                                                        return;
                                                    }
                                                    
                                                    // Add new entry (simple add like mobile)
                                                    setState(prevState => ({
                                                        ...prevState,
                                                        zipcodeList: [...prevState.zipcodeList, { zipcode: '', radius: '' }],
                                                        radiusError: ''
                                                    }));
                                                }}
                                            >
                                                + Add Service Area
                                            </span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                        
                        {/* General radius error */}
                        {state.radiusError && (
                            <p className="ebw-input__error mt-0 mb-2 text-left">
                                {state.radiusError}
                            </p>
                        )}
                    </div>
                </Col>
            </Row>

            <Row form className="mt-3">
                <Col sm="12">
                    <InputNumber
                        label="Years of business experience *"
                        name="yearsOfBusiness"
                        id="register_yobus"
                        value={state.yearsOfBusiness}
                        error={state.yearsOfBusinessError}
                        changeEvent={handleInputChange}
                    />
                </Col>
            </Row>

            <Row className="mt-2">
                <Col xs="12" md="4" lg="4" className="mx-auto">
                    <Buttons text="Next" type="submit" />
                </Col>
            </Row>
        </Form>
    );
}
export default RegisterBusiness;